import "./App.css";
import WeatherComponents from "./weather";

function App() {

    return (
        <>
        <WeatherComponents/>
        </>
    );
}

export default App;
